import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// const baseUrl = process.env.REACT_BACKEND_ENDPOINT;
const baseUrl = "https://vaamoz.com/vampayUserAppNew";

export const vaamozApi = createApi({
  reducerPath: "vaamozApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("Origin", "https://vaamoz.com");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    upiPayment: builder.mutation({
      query: (body: { link_id: string; upi_id: string; amount: string }) => ({
        url: "/PaymentLinkInitiateUpiCollect",
        method: "POST",
        body: {
          link_id: body.link_id,
          upi_id: body.upi_id,
          amount: body.amount,
        },
      }),
    }),
  }),
});

export const { useUpiPaymentMutation } = vaamozApi;
